import { render, staticRenderFns } from "./GoToRoute.vue?vue&type=template&id=68d030d4&"
import script from "./GoToRoute.vue?vue&type=script&lang=js&"
export * from "./GoToRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports